import { c as _c } from "react/compiler-runtime";
import analytics, { getDonationFormType } from 'product-analytics';
import { useCallback, useState } from 'react';
import { useDonationFormConfig, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
function useCodonationModalState() {
  const $ = _c(11);
  const {
    receiverId,
    receiverType,
    channel,
    showCodonation
  } = useDonationFormConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["codonation_cents"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [codonationCents] = useDonationFormValues(t0);
  const [modalShown, setShowCodonationModal] = useState(false);
  let t1;
  if ($[1] !== channel || $[2] !== receiverId || $[3] !== receiverType || $[4] !== showCodonation) {
    t1 = () => {
      setShowCodonationModal(true);
      analytics.coDonationModalOpened({
        donation_form_type: getDonationFormType({
          receiverId,
          receiverType,
          channel,
          showCodonation
        }),
        id: receiverId,
        receiver_type: receiverType
      });
      const ele = document.activeElement as HTMLElement | null;
      ele?.blur();
    };
    $[1] = channel;
    $[2] = receiverId;
    $[3] = receiverType;
    $[4] = showCodonation;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const openModal = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShowCodonationModal(false);
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const hideModal = t2;
  let t3;
  if ($[7] !== codonationCents || $[8] !== modalShown || $[9] !== openModal) {
    t3 = {
      modalShown,
      openModal,
      hideModal,
      codonationCents
    };
    $[7] = codonationCents;
    $[8] = modalShown;
    $[9] = openModal;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export default useCodonationModalState;